import { takeEvery } from 'redux-saga/effects';
import { saveFileForUpload } from '../actions/file-upload';
import { openSGDialog } from '../actions/sg-dialog';
import { OPEN_FILE_UPLOAD_WINDOW } from '../constants';
import { DIALOGS } from '../constants/sg-dialog';
import { store } from '../store';

const FILE_UPLOAD_ELEMENT_ID = 'chat-file-upload';
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_FILE_FORMATS = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/jpg',
  'image/tiff',
  'application/pdf',
  'application/json',
  'text/plain',
  'text/xml',
  'application/xml',
  'video/mpeg',
  'video/3gpp',
  'video/x-msvideo',
  'message/rfc822'
];

function* browserFileUpload() {
  if (document.getElementById(FILE_UPLOAD_ELEMENT_ID)) {
    document.body.removeChild(document.getElementById(FILE_UPLOAD_ELEMENT_ID));
  }

  const tempInput = document.createElement('input');
  tempInput.style.cssText = 'position: absolute; left: -1000px; top: -1000px';
  tempInput.id = FILE_UPLOAD_ELEMENT_ID;
  tempInput.type = 'file';
  tempInput.accept = ACCEPTED_FILE_FORMATS.join(', ');

  tempInput.onchange = (event) => {
    // @ts-ignore
    const file = event.target.files[0];

    if (file.size >= MAX_FILE_SIZE) {
      store.dispatch(openSGDialog(DIALOGS.FILE_UPLOAD_VALIDATION));
      document.body.removeChild(document.getElementById(FILE_UPLOAD_ELEMENT_ID));
      return;
    }

    const reader = new FileReader();
    reader.onload = function () {
      const dataURL = reader.result;
      store.dispatch(
        saveFileForUpload({
          file: {
            name: file.name,
            file: dataURL
          }
        })
      );
    };
    reader.readAsDataURL(file);
  };

  document.body.appendChild(tempInput);
  tempInput.click();
}

function* browserUpload() {
  yield takeEvery(OPEN_FILE_UPLOAD_WINDOW, browserFileUpload);
}

export default browserUpload;
